<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chapter-title---IVP" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Contents</h2>
<div>
<div id="_idContainer002">
<p class="veryfirst"><b>Part 1: Engaging Diverse Contexts</b></p>
<p class="first"><a href="#/Text/ch1#_idTextAnchor001">1 Flexibility</a></p>
<p class="first"><a href="#/Text/ch2#_idTextAnchor009">2 Plausibility and Desirability</a></p>
<p class="first"><span href="#/Text/ch3#_idTextAnchor017" title="Link target outside of Sample">3 Tangibility</span></p>
<p class="firstleft"><b>Part 2: Engaging the Spiritual But Not Religious</b></p>
<p class="first"><span href="#/Text/ch4#_idTextAnchor030" title="Link target outside of Sample">4 The Temple in the Desert and the Mysterious Massage</span></p>
<p class="first"><span href="#/Text/ch5#_idTextAnchor041" title="Link target outside of Sample">5 Does Christianity Enable a Richer Spirituality?</span></p>
<p class="first"><span href="#/Text/ch6#_idTextAnchor052" title="Link target outside of Sample">6 Inviting Others into an Experience of Christian Spirituality</span></p>
<p class="firstleft"><b>Part 3: Engaging Atheists</b></p>
<p class="first"><span href="#/Text/ch7#_idTextAnchor057" title="Link target outside of Sample">7 Dawkins on a Bike (and Other Tales)</span></p>
<p class="first"><span href="#/Text/ch8#_idTextAnchor079" title="Link target outside of Sample">8 Isn’t Faith in God Irrational and Outdated?</span></p>
<p class="first"><span href="#/Text/ch9#_idTextAnchor117" title="Link target outside of Sample">9 Creating Safe Spaces for Exploring Questions</span></p>
<p class="firstleft"><b>Part 4: Engaging Nominal Christians</b></p>
<p class="first"><span href="#/Text/ch10#_idTextAnchor119" title="Link target outside of Sample">10 The Pimp, the Planter and Their Friends</span></p>
<p class="first"><span href="#/Text/ch11#_idTextAnchor137" title="Link target outside of Sample">11 Don’t You Realize I’ve Been There and Done That?</span></p>
<p class="first"><span href="#/Text/ch12#_idTextAnchor147" title="Link target outside of Sample">12 Communities That Facilitate Rediscovering Jesus</span></p>
<p class="first"><span href="#/Text/epilogue#_idTextAnchor154" title="Link target outside of Sample">Epilogue: Adventures with Ukrainian Comic Book Jesus</span></p>
<p class="first"><span href="#/Text/appendix1#_idTextAnchor156" title="Link target outside of Sample">Appendix 1: Comparative Statistics for Canada and the United Kingdom</span></p>
<p class="first"><span href="#/Text/appendix2#_idTextAnchor163" title="Link target outside of Sample">Appendix 2: Did God Command Genocide?</span></p>
<p class="first"><span href="#/Text/appendix3#_idTextAnchor167" title="Link target outside of Sample">Appendix 3: Suggested Further Reading</span></p>
<p class="first"><span href="#/Text/acknowledgements#_idTextAnchor168" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="first"><span href="#/Text/notes#_idTextAnchor169" title="Link target outside of Sample">Notes</span></p>
<p class="first"><span href="#/Text/praise#_idTextAnchor322" title="Link target outside of Sample">Praise for <i class="i">The Myth of the Non-Christian</i></span></p>
<p class="first"><span href="#/Text/author#_idTextAnchor323" title="Link target outside of Sample">About the Author</span></p>
<p class="first"><span href="#/Text/moreIVP#_idTextAnchor324" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="first"><span href="#/Text/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?bdb2f0f2